import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/modules/Auth'
import Activated from '@/components/Activated'
import Day from '@/components/Day'
import Register from '@/components/Register'
import ConfirmLogin from '@/components/ConfirmLogin'
import CourseList from '@/components/CourseList'
import HomeworkList from '@/components/HomeworkList'
import Homework from '@/components/Homework'
import CourseInstance from '@/components/CourseInstance'
import Schedule from '@/components/Schedule'
import Links from '@/components/Links'
import Settings from '@/components/Settings'
import Debug from '@/components/Debug'
import Error from '@/components/Error'
import logger from '@/modules/Logger'
import http from '@/modules/Http'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: ConfirmLogin
    },
    {
      path: '/activated',
      name: 'activated',
      component: Activated
    },
    {
      path: '/',
      redirect: '/homeworks'
    },
    {
      path: '/day',
      name: 'day',
      component: Day
    },
    {
      path: '/homeworks',
      name: 'homeworks',
      component: HomeworkList
    },
    {
      path: '/homework/:id',
      name: 'homework',
      component: Homework
    },
    {
      path: '/courses',
      name: 'courses',
      component: CourseList
    },
    {
      path: '/course/:id',
      name: 'course',
      component: CourseInstance
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/links',
      name: 'links',
      component: Links
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    {
      path: '/debug',
      name: 'debug',
      component: Debug
    }
  ]
})

router.beforeEach((to, from, next) => {
  switch (to.path) {
    case '/logout':
      auth.logout()
      router.push('/')
      return
    case '/authenticate':
      auth.authenticate(to.query.code)
      return
    case '/register':
    case '/confirm':
      if (auth.isProfileAuthenticated()) {
        next()
        return
      }
      break
    // public access
    case '/error':
      if (auth.isProfileAuthenticated()) {
        router.push('/')
      }
      next()
      return
    case '/debug':
      next()
      return
  }

  if (auth.isSessionAuthenticated()) {
    next()
  } else {
    auth.checkServerLoginStatus(to.path)
  }
})

// Add a response interceptor
http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response !== undefined && error.response.status === 401) {
      auth.checkServerLoginStatus(this.a.app.$route.fullPath)
    } else if (error.response === undefined) {
      logger.log('error', error.message)
      router.push('debug')
    }
    return Promise.reject(error)
  })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js